import React from "react";
import isEmpty from "lodash/isEmpty";

const FallbackImage = (props) => {
  const {
    src,
    alt,
    height = 150,
    width = 150,
    fallbackWidth = 150,
    fallbackHeight = 90,
  } = props;
  return isEmpty(props.src) ? (
    <img
      height={height}
      width={width}
      alt={alt}
      src="/assets/img/placeholder.svg"
      onError={(e) => {
        e.target.src = "/assets/img/placeholder.svg";
        e.target.height = fallbackHeight;
        e.target.width = fallbackWidth;
        // e.target.style.filter =
        //     'invert(38%) sepia(47%) saturate(3461%) hue-rotate(126deg) brightness(92%) contrast(102%)'

        return e;
      }}
    />
  ) : (
    <img
      height={height}
      width={width}
      alt={alt}
      src={src}
      onError={(e) => {
        e.target.src = "/assets/img/placeholder.svg";
        e.target.height = fallbackHeight;
        e.target.width = fallbackWidth;
        // e.target.style.filter =
        //     'invert(38%) sepia(47%) saturate(3461%) hue-rotate(126deg) brightness(92%) contrast(102%)'

        return e;
      }}
    />
  );
};

export default FallbackImage;
